import { Link } from "react-router-dom";
import { Heart, Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";

export default function BuddyCard({ buddy, index = 0 }) {
  const { add } = useCart();
  const [wished, setWished] = useState(false);
  const comingSoon = buddy.availability === "coming_soon";

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.08 }}
      whileHover={{ y: -6 }}
      className="group relative flex w-64 shrink-0 flex-col overflow-hidden rounded-[2rem] bg-white shadow-[0_10px_40px_rgba(16,42,86,0.07)] sm:w-72"
      data-testid={`buddy-card-${buddy.slug}`}>
      <div className="relative overflow-hidden bg-blush/60">
        <img src={buddy.image} alt={`${buddy.name} the ${buddy.animal} plush bedtime companion`} loading="lazy"
          className="aspect-[2/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <button
          onClick={() => { setWished(!wished); toast(wished ? "Removed from wishlist" : `${buddy.name} added to wishlist`); }}
          aria-label={`Add ${buddy.name} to wishlist`} data-testid={`wishlist-${buddy.slug}`}
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/85 shadow backdrop-blur transition hover:scale-110">
          <Heart size={17} className={wished ? "fill-pink text-pink" : "text-navy/50"} />
        </button>
        {comingSoon && (
          <span className="absolute left-4 top-4 rounded-full bg-lavdeep px-3 py-1 font-display text-xs font-semibold text-navy" data-testid={`coming-soon-${buddy.slug}`}>
            COMING SOON
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[11px] font-bold uppercase tracking-widest text-pinkdeep">{buddy.personality}</p>
        <h3 className="mt-1 font-display text-xl font-semibold text-navy">{buddy.name} the {buddy.animal}</h3>
        <p className="mt-1.5 text-[13px] italic text-navy/50">“{buddy.quote}”</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="font-display text-lg font-semibold text-navy">${buddy.price.toFixed(2)}</span>
          <div className="flex gap-2">
            {!comingSoon && (
              <button onClick={() => { add(buddy); toast.success(`${buddy.name} is in your cart!`); }}
                aria-label={`Quick add ${buddy.name} to cart`} data-testid={`quick-add-${buddy.slug}`}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-blush text-navy transition hover:bg-pink">
                <Plus size={16} />
              </button>
            )}
            <Link to={`/buddy/${buddy.slug}`} data-testid={`meet-${buddy.slug}`}
              className="rounded-full bg-pink px-4 py-2 font-display text-[11px] font-semibold tracking-wide text-navy transition hover:bg-moon">
              MEET {buddy.name.toUpperCase()}
            </Link>
          </div>
        </div>
      </div>
    </motion.article>
  );
}
